import { useAuth } from "@lib/auth/useAuth";
import type { UspBannerModel } from "@lib/contentful/mappers/mapUspBanner";
import { eccoClubHorizontalGradient, saleSeasonGradient } from "@ecco/ui/tokens/colors";
import { getAnimatedContainerStyle } from "../USPbanner.styles";

interface UseUSPBannerConfigProps {
    uspBanner: UspBannerModel;
    backgroundColor?: string;
}

export const useUSPBannerConfig = ({ uspBanner, backgroundColor }: UseUSPBannerConfigProps) => {
    const { isLoggedIn } = useAuth();

    const { isSaleSeason, isEccoClub, messages: uspMessages } = uspBanner;

    // Show sale season colors only when it's sale season AND user is not authenticated
    const shouldShowSaleColors = isSaleSeason && !isLoggedIn;
    const shouldShowEccoClubColors = isEccoClub;

    let bannerBackground: string;

    if (shouldShowSaleColors) {
        bannerBackground = saleSeasonGradient;
    } else if (shouldShowEccoClubColors) {
        bannerBackground = eccoClubHorizontalGradient;
    } else {
        bannerBackground = backgroundColor || "gray.100";
    }

    const animatedContainerStyle = getAnimatedContainerStyle(
        shouldShowSaleColors || shouldShowEccoClubColors
    );

    return {
        bannerBackground,
        animatedContainerStyle,
        uspMessages,
        isSaleSeason: shouldShowSaleColors,
    };
};
